import { toNormalizedTagName } from '@fullstory/rewriters';
import { ASSIGNED_NODE_TAG } from '@fullstory/shared/node_decoder';
import type { FsDocument } from './fsdocument';
import { FsNode } from './fsnode';

/**
 * FsAssignedNode is a pseudo element that acts as the parent of assignedNodes of a polyfill shadow slot.
 * This is handled specially, unlike assignedNodes for _actual_ shadow slots.
 */
export class FsAssignedNodes extends FsNode {
  constructor(ownerDoc: FsDocument, fsid?: number) {
    super(ownerDoc, toNormalizedTagName(ASSIGNED_NODE_TAG), '', fsid);
  }

  ensureNode() {
    // renders children of this node to the slot parent
    this.dom = this.parent?.dom ?? null;
  }
}
